import type { FaireProductEntity } from "../../entity_types/product";

export const p_hkgrpa7q7j: FaireProductEntity = {
  token: "p_hkgrpa7q7j",
  type: "product",
  name: "Sonia Sweater Tee - Glow (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/3aa564cae729500a167c8e5a30be66564ef2feaabe68f681a42157e49eb604b6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f26fdaec20ea33f41f7543116696e29a62640327a317907fef41816b09975fe.jpeg",
    "https://cdn.faire.com/fastly/9355e468727734f6c144b06bc101fe42a4b4b3b14073269c39a06b2791aebff4.jpeg",
    "https://cdn.faire.com/fastly/fa719c9b170a894dabe43c9af22da6e98dd75b53ca9affbe3004522f128a24b7.jpeg",
    "https://cdn.faire.com/fastly/76bc92dfb09e7b17ed600dce7e0ccae738b4c897ab27cb86c98b66c6bba5f99a.jpeg",
    "https://cdn.faire.com/fastly/9f01126cf8936b29ae9c6ebf3ab81283b0b353c7bd288ee19cf3bb4307a6bd12.jpeg",
    "https://cdn.faire.com/fastly/9f6b9a4d15f85491467093e1e1c1ac4ce5ad35629916f573733c04b66ce5015f.jpeg",
    "https://cdn.faire.com/fastly/9881970ec93361e24e34e1f518d73f70c6ae994095a9289b0d4150a3901afec8.jpeg",
    "https://cdn.faire.com/fastly/29a9d18172798de52ef82d21c3dd7bc5660c53c577f6ba106c69ab42dfb94488.jpeg",
    "https://cdn.faire.com/fastly/1a58619328b940a5aff2250c464226e929a3e96f926bcdeb22c7ba707a5e01f2.jpeg",
    "https://cdn.faire.com/fastly/fe7ed2de2c310ee2f8fd1609c9b542a691ceb2c94aa04ef83d75a3544b692200.jpeg",
    "https://cdn.faire.com/fastly/756b6aa3cb9b858272a2e2a649b12e5868585ec2ae3b00fb4c9bd1a4196a74c5.jpeg"
  ],
  priceDollars: 80.1,
  description: "The Sonia Sweater Tee brings bold geometry and effortless versatility together in one piece. Knit from 100% cotton, its richly colored checkerboard pattern is inspired by the playful balance of color and form found in modernist art. The relaxed fit and soft, breathable knit make it an easy choice for everyday wear, whether layered through the seasons or worn on its own.\n\n * 100% Cotton \n * Soft, breathable knit \n * Relaxed fit \n * Made in Peru \n * Ethically crafted in small batches ",
  tags: [],
  msrpDollars: 178,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:24.363Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
